import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const fileUploadDefaultVariants = {
  "size": "md"
}
const fileUploadCompoundVariants = []

const fileUploadSlotNames = [
  [
    "root",
    "fileUpload__root"
  ],
  [
    "input",
    "fileUpload__input"
  ],
  [
    "button",
    "fileUpload__button"
  ],
  [
    "preview",
    "fileUpload__preview"
  ],
  [
    "filename",
    "fileUpload__filename"
  ]
]
const fileUploadSlotFns = /* @__PURE__ */ fileUploadSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, fileUploadDefaultVariants, getSlotCompoundVariant(fileUploadCompoundVariants, slotName))])

const fileUploadFn = memo((props = {}) => {
  return Object.fromEntries(fileUploadSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const fileUploadVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...fileUploadDefaultVariants, ...compact(variants) })

export const fileUpload = /* @__PURE__ */ Object.assign(fileUploadFn, {
  __recipe__: false,
  __name__: 'fileUpload',
  raw: (props) => props,
  variantKeys: fileUploadVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, fileUploadVariantKeys)
  },
  getVariantProps
})